var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStokeTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD8E8",
    fillRule: "evenodd",
    d: "M12 3C13.621 3 15.121 3.40524 16.5 4.21573C17.879 5.02621 18.9738 6.12097 19.7843 7.5C20.5948 8.87903 21 10.379 21 12C21 13.621 20.5948 15.121 19.7843 16.5C18.9738 17.879 17.879 18.9738 16.5 19.7843C15.121 20.5948 13.621 21 12 21C10.379 21 8.87903 20.5948 7.5 19.7843C6.12097 18.9738 5.02621 17.879 4.21573 16.5C3.40524 15.121 3 13.621 3 12C3 10.379 3.40524 8.87903 4.21573 7.5C5.02621 6.12097 6.12097 5.02621 7.5 4.21573C8.87903 3.40524 10.379 3 12 3ZM12 4.5C10.6453 4.5 9.40786 4.83432 8.26003 5.50892C7.10122 6.18998 6.18998 7.10122 5.50892 8.26003C4.83432 9.40786 4.5 10.6453 4.5 12C4.5 13.3547 4.83432 14.5921 5.50892 15.74C6.18998 16.8988 7.10122 17.81 8.26003 18.4911C9.40786 19.1657 10.6453 19.5 12 19.5C13.3547 19.5 14.5921 19.1657 15.74 18.4911C16.8988 17.81 17.81 16.8988 18.4911 15.74C19.1657 14.5921 19.5 13.3547 19.5 12C19.5 10.6453 19.1657 9.40786 18.4911 8.26003C17.81 7.10122 16.8988 6.18998 15.74 5.50892C14.5921 4.83432 13.3547 4.5 12 4.5ZM11 12.75H16.75V11.25H12.5V7H11V12.75Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStokeTimer);
export default __webpack_public_path__ + "static/media/stoke_timer.718098a8.svg";
export { ForwardRef as ReactComponent };